import axios from "axios";

export const rewardTierService = {
  async create(payload) {
    return await axios.post("/reward-tier", payload);
  },
  async remove(id) {
    return await axios.delete("/reward-tier/" + id);
  },
  async view(id) {
    return await axios.get("/reward-tier/" + id);
  },
  async update(id, payload) {
    return await axios.patch("/reward-tier/" + id, payload);
  },
};
